module.exports = new __parcel__URL__("diamond1.200d0382.png").toString();